import { STREAM_TOKEN } from '../../common/const';
import { AuthServiceCore } from '../../index';
import Cookie from 'js-cookie';
import Sentry from "./sentry";

export class StreamServiceCore {
  static instance = null;

  constructor() {
    this.promise = null;
    this.channel = {
      broadcast: null,
      resolve: null,
      reject: null,
    };
    Cookie.remove(STREAM_TOKEN);

    this.initPagesSteamsApi();
  }

  initPagesSteamsApi() {
    if (!this.channel.broadcast) {
      this.channel.broadcast = new BroadcastChannel('AuthServiceStream');
      this.channel.broadcast.onmessage = (message) => {
        const messageData = message.data;

        if (messageData.status === 'pending') {
          Sentry.getPendingMessage()

          this.promise = new Promise((resolve, reject) => {
            this.channel.resolve = resolve;
            this.channel.reject = reject;
          });
        }

        if (messageData.status === 'resolve') {
          Sentry.getResolveMessage()

          this.channel.resolve({
            access_token: AuthServiceCore.getAccessToken(),
          });
        }

        if (messageData.status === 'reject') {
          Sentry.getRejectMessage()
          this.channel.reject('API stream error');
        }
      };

      Sentry.createBroadcast()
    }
  }

  isOpen() {
    return Boolean(Cookie.get(STREAM_TOKEN));
  }

  open() {
    Cookie.set(STREAM_TOKEN, true);
    this.syncPagesSteams('pending');

    Sentry.openStream()
  }

  close() {
    Cookie.remove(STREAM_TOKEN);
    this.promise = null;

    Sentry.closeStream();
  }

  syncPagesSteams(status, values = {}) {
    this.channel.broadcast.postMessage({
      status,
      ...values,
    });

    Sentry.sendBroadcastMessage(status)
  }

  static getInstance() {
    if (!StreamServiceCore.instance) {
      StreamServiceCore.instance = new StreamServiceCore();
    }

    return StreamServiceCore.instance;
  }
}

export const StreamService = StreamServiceCore.getInstance();
export default StreamService;